import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Gtp } from 'src/app/shared/gtp';

import { Subscription } from 'rxjs';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { PageEvent } from '@angular/material/paginator';

import Swal from 'sweetalert2';
import { UsuariosService } from 'src/app/services/admin/usuarios/usuarios.service';

@Component({
  selector: 'app-usuarios-tabla',
  templateUrl: './usuarios-tabla.component.html',
  styleUrls: ['./usuarios-tabla.component.scss']
})
export class UsuariosTablaComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort; 
  pageEvent: PageEvent;

  @Output() statusTabla = new EventEmitter();
  
    //TABLA
    public ELEMENT_DATA = [];
    public filter: any = {
      id : null,
      nombre : '',
      //observacion: '',
      opciones: null,
      buscar: '',
      orderby: 'id',
      sortby: 'asc',
      pageIndex: 0,
      pageSize: 5,
    };
    public contClass: string = 'container-fluid maincont';
    public dataSource: MatTableDataSource<any>;

    public tableCount;
    public loading: boolean = false;  
    public tableDisplay : Boolean = false;

    displayedColumns: string[] = [ 'id', 'nombre', 'perfil', 'opciones'];
  constructor(
    private gtp: Gtp,
    private cdRef:ChangeDetectorRef,
    private usuarioCall:UsuariosService

  ) { 
    this.loadInforme()
  }

  ngOnInit(): void {
    //cargamos los datos traidos en la tabla
    this.getCargarTabla()

  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  loadInforme(){
    this.loading = true;
    this.usuarioCall.getUsuariosListar().subscribe(res => {
      //console.log(res)
      this.usuarioCall.setContenidoTabla(res['usuarios'])
    });

  }

  getCargarTabla(){
    this.usuarioCall.getContenidoTablaObs().subscribe(res => {
      //console.log(res)
        res.forEach((valor) => {
          switch (valor.cod_perfil) {
            case 3:
              valor.perfil = 'Operario';
              break;
              case 2:
                valor.perfil = 'Administrador';
              break;
              case 5:
                valor.perfil = 'Limitado';
              break;
            default:
              valor.perfil = '';

            break;
          }
        });
        //console.log(res)
        this.dataSource = new MatTableDataSource(res);
        //console.log(this.dataSource)

        this.tableCount = res.length;
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        
        this.loading = false;
        this.tableDisplay = true;
    });
  }

  containerSize(){
    this.contClass = this.gtp.containerSize(this.contClass);
  }

  cerrarTabla(){
    this.gtp.cerrarVentanas(true);    
  }

  setSort(event?) {
    this.filter.orderby = event.active;
    this.filter.sortby = event.direction;
    //this.loadInforme();
  }

  setPagination(event?) {
    this.filter.pageIndex = parseInt(event.pageIndex);
    this.filter.pageSize = parseInt(event.pageSize);
    //this.loadInforme();
    return event;
  }

  getPageSizeOptions(): number[] {    
    return [10, 20, this.tableCount];
  }

  applyFilter() {
    this.dataSource.filter = this.filter.buscar.trim().toLowerCase();
  }

  toggleEditar(el){

    this.usuarioCall.setFormData(el);
  }

  toggleEliminar(el){
    //console.log(el)
    Swal.fire({
      title: 'Atención!, Esta Seguro de Eliminar?',
      text: ' Usuario: '+ el.usuario,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Si, Borrar!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.usuarioCall.usuarioEliminar(el).subscribe(res => {
          this.usuarioCall.setContenidoTabla([]); 
          Swal.fire(
            'Buen Trabajo!',
            'El usuario fue eliminado correctamente',
            'success'
          )

        }, function(error){
          Swal.fire(
            'Epa..!',
            error,
            'error'
          )
        });
      }

      setTimeout(() => {
        this.loadInforme()
      }, 2000);
    })
  }
}
